import React, { useMemo } from 'react';

import { clsx } from 'js/app/utils/clsx.util';

import style from './IFrameWidget.scss';

export const IFrameWidget = ({ customCategory, viewModeDetailed, inAllCategory }) => {
    const {
        heightOfWidget,
        heightOfWidgetList,
        showWidgetInAll,
        showWidgetInGeneral,
        widgetUrl
    } = customCategory;

    // ADD WIDGET
    const isWidget = (inAllCategory ? showWidgetInAll : showWidgetInGeneral) && widgetUrl?.length > 0;
    const iframeHeight = viewModeDetailed ? heightOfWidget : heightOfWidgetList;
    const iframeInner = useMemo(
        () => (
            <iframe
                src={widgetUrl}
                className={style.iframe}
            />
        ),
        [widgetUrl]
    );

    if (!widgetUrl) {
        return null;
    }

    if (isWidget && viewModeDetailed) {
        return (
            <div
                className={clsx(
                    style.container,
                    { [style[`block_widget_size_${iframeHeight}`]]: viewModeDetailed }
                )}
            >
                {iframeInner}
            </div>
        );
    }

    return (
        <div className={style.wrapper}>
            <div className={style.aspectWrapper}>
                <div
                    className={clsx(style.container, {
                        [style[`aspect_widget_size_${iframeHeight}`]]: !viewModeDetailed
                    })}
                />
            </div>

            {iframeInner}
        </div>
    );
};
